import { render, staticRenderFns } from "./veStuCheckModifyMy.vue?vue&type=template&id=36a2e9ae&scoped=true"
import script from "./veStuCheckModifyMy.vue?vue&type=script&lang=js"
export * from "./veStuCheckModifyMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2e9ae",
  null
  
)

export default component.exports